module.exports = {
  mmzs: 'หมายเหตุเนื่องจากรหัสผ่าน PAD มือถือไม่สนับสนุนอักขระพิเศษทั้งหมดตัวละครพิเศษสามารถใช้ได้เฉพาะเมื่อตั้งค่ารหัสผ่านสำหรับระบบการติดตามบัญชี',
  mqzwdbcl: 'ไม่มีอะไรที่ต้องทำตอนนี้！',
  cxyzzjjkfz: 'โปรแกรมลิงอยู่ภายใต้การพัฒนาอย่างเร่งด่วน！',
  yhtymh: 'ประตูสู่ความสามัคคีของทะเล',
  thtymhqxqbxt: 'ระบบทั้งหมดของ Yihai รวมพอร์ทัล',
  ghbj: 'เปลี่ยนพื้นหลัง',
  hymr: 'เรียกคืนค่าปริยาย',
  ckgd: 'ดูเพิ่มเติม',
  qd: 'แน่ใจ',
  qr: 'ยืนยัน',
  qx: 'ยกเลิก',
  tc: 'ออก',
  czcg: 'ปฏิบัติการสำเร็จแล้ว',
  wxts: 'คำแนะนำ ที่ดี',
  cw: 'ผิดพลาด',
  jg: 'คำเตือน',
  // 登录页
  loginPage: {
    qhqyzm: 'ได้รับรหัสการตรวจสอบ',
    tysfglpt: 'รวมระบบพอร์ทัล',
    zhdl: 'ล็อกอินบัญชีผู้ใช้',
    yhmygbh: 'ชื่อผู้ใช้/หมายเลขพนักงาน',
    sjhm: 'โทรศัพท์มือถือ',
    xgmm: 'แก้ไขรหัสผ่าน',
    mm: 'รหัสผ่าน',
    qxgcsmm: 'โปรดแก้ไขรหัสผ่านเริ่มต้น',
    mmydqqxgmm: 'รหัสผ่านหมดอายุแล้วโปรดแก้ไขรหัสผ่าน',
    xmmbnyjmmxt: 'รหัสผ่านใหม่จะไม่เหมือนกับรหัสผ่านเก่า',
    xmm: 'รหัสผ่านใหม่',
    ymm: 'รหัสผ่านเดิม',
    qrxmm: 'ยืนยันรหัสผ่านใหม่',
    wjmm: 'ลืมรหัสผ่าน',
    xyhddl: 'เลื่อนล็อกอินไปทางขวา',
    yzcg: 'ตรวจสอบเรียบร้อยแล้ว',
    smdl: 'ล็อกอินรหัสการค้นหา',
    qywxsm: 'รหัสย่อขยายธุรกิจ',
    ddsm: 'ตอกตะปู',
    ewmysx: 'ระบบสองระบบไม่ทำงาน',
    sxewm: 'รีเฟรชรหัสผ่าน',
    dxyzm: 'รหัสตรวจสอบข้อความ',
    hqyzm: 'กำลังรับรหัสยืนยัน',
    xyb: 'ขั้นต่อไป',
    dlsjyz: 'ยืนยันการล็อกอินโทรศัพท์',
    wbll: 'เชื่อมโยงภายนอก',
    bq: 'สงวนลิขสิทธิ์',
    mmbyz: 'รหัสผ่านไม่ตรงกัน',
    hcxhq: 'ดึงข้อมูลกลับมา',
    qxsrzqdsjhm: 'กรุณาใส่เบอร์ ที่ถูกต้อง',
    qsrdxyzm: 'โปรดป้อนรหัสการตรวจสอบข้อความ',
    qsryhm: 'โปรดป้อนชื่อผู้ใช้',
    qxzsjhm: 'เลือกหมายเลขโทรศัพท์มือถือ',
    fscg: 'การส่งสำเร็จแล้ว',
    yhmbnwk: 'ชื่อผู้ใช้ไม่สามารถว่า งได้',
    yhmwgzf: 'ชื่อผู้ใช้ 3-12 ตัวอักษร',
    yhmbnczkg: 'ชื่อผู้ใช้/หมายเลขลูกจ้างไม่สามารถมีช่องว่า งได้',
    mmbnwk: 'รหัสผ่านไม่สามารถว่า งได้',
    ymmbnwk: 'รหัสผ่านเดิมไม่สามารถว่า งเปล่าได้',
    mmwsfzhlw: 'รหัสเป็นเลข 6 หลัก',
    mmzswzmsztszf: 'รหัสผ่านมีอย่างน้อย 10 บิตตัวเลขตัวเลขตัวอักษรพิเศษ',
    mmzswzmsztszfnew: 'รหัสผ่านมีอย่างน้อย 10 บิตตัวเลขตัวเลขตัวอักษรพิเศษ，ตัวอักษรพิเศษสามารถใช้สำหรับ'
  },
  // 首页
  homePage: {
    ty: 'ภาษาไทย',
    hy: 'ภาษาเกาหลี',
    gh: 'หมายเลขงาน',
    zh: 'หมายเลขบัญชี',
    gw: 'ตำแหน่ง',
    sj: 'มือถือ',
    yx: 'กล่องจดหมาย',
    yy: 'ภาษา',
    pf: 'ผิวหนัง',
    bj: 'พื้นหลัง',
    yh: 'ตัวแทนค้าต่าง',
    xtyyxz: 'การเลือกภาษาของระบบ',
    zwjt: 'ภาษาจีนประยุกต์',
    zwft: 'ภาษาจีนดั้งเดิม',
    yw: 'ภาษาอังกฤษ',
    qb: 'ทั้งหมด',
    wdyy: 'แอพของฉัน',
    dlbjxgqh: 'ลูกเล่นการสลับพื้นหลังของล็อกอิน',
    zjbj: 'พื้นหลังกลาง',
    ybbj: 'พื้นหลังด้านขวา',
    qhdlr: 'สลับตัวแทน',
    xtpfqh: 'การสลับระบบผิวหนัง',
    oa: 'OA',
    fkxt: 'ควบคุมค่าใช้จ่าย',
    hwcrm: 'CRM นอกทวีป',
    hr: 'HR',
    crm: 'คอนติเนนตัล CRM',
    zj: 'การแจ้งเตือนเอกสาร',
    srm: 'SRM'
  },
  // 后台返回信息
  interface: {
    dlsx: 'การล็อกอินล้มเหลว',
    dlsxqcxdl: 'การล็อกอินไม่ทำงานกรุณาล็อกอินใหม่',
    fail: 'โคเด้ดกลับไป ที่แฟร์',
    404: 'ความผิดปกติของเครือข่าย',
    '0000': 'ข้อผิดพลาดปริยาย',
    1000: 'พารามิเตอร์ผิด',
    2000: 'การซิงค์เนื้อเยื่อ หรือหน่วยงานล้มเหลว',
    3000: 'มีชื่อตัวละครระบบอยู่แล้ว',
    3001: 'มีการตั้งค่าพนักงานอยู่แล้ว และไม่สามารถลบออกได้',
    3002: 'แพลตฟอร์มข้อความผิดปกติ',
    8001: 'การเข้าถึงข้อมูลจดหมายล้มเหลว',
    9997: 'การล็อกอินล้มเหลว',
    9998: 'การร้องขอ ที่ผิดกฎหมาย',
    9999: 'ระบบผิดพลาด',
    10001: 'มีชื่อนี้ อยู่แล้ว',
    // 10021: '唯一标识已存在',
    10002: 'ปฏิบัติการล้มเหลว',
    10003: 'มีหมายเลขพนักงานอยู่แล้ว',
    10004: 'หมายเลขพนักงาน: ตัวเลขบริสุทธิ์',
    10005: 'หมายเลขโทรศัพท์มือถือ: ไม่ใช่',
    10006: 'รหัสผ่าน: อักขระ 8-16 บิต',
    10007: 'หมายเลขไอดี: ป้อนข้อมูลไม่ถูกต้อง',
    10008: 'หมายเลขหนังสือเดินทาง: ป้อนไม่ถูกต้อง',
    10009: 'กล่องจดหมาย: รูปแบบไม่ถูกต้อง',
    10010: 'รหัสผ่านไม่ถูกต้อง',
    10011: 'ชื่อบัญชี หรือรหัสผ่านผิดพลาดการล็อกอินล้มเหลว',
    10012: 'ยังไม่มีชื่อบัญชี',
    10013: 'การล็อกอินของผู้ใช้หมดอายุแล้ว',
    10014: 'หมายเลขบัญชีถูกล็อคแล้วเนื่องจากการล็อกอินล้มเหลวมากกว่า สิบครั้ง',
    10015: 'รหัสการตรวจสอบไม่ถูกต้อง',
    10016: 'หมายเลขโทรศัพท์ใช้ไม่ได้',
    10017: 'หมดเวลาตรวจสอบรหัสผ่าน',
    10018: 'ล้มเหลวในการปรับปรุงรหัสสองมิติใหม่อีกครั้ง',
    10019: 'รหัสเดียวกันทุกวันอนุญาตให้ส่งได้แค่สามครั้ง',
    10020: 'การส่งรหัสผ่านล้มเหลว',
    10021: 'การล็อกอินอัตโนมัติล้มเหลว',
    10022: 'การล็อกอินล้มเหลวมากกว่า 5 ครั้งกรุณาใส่รหัสยืนยัน',
    10023: 'ล้มเหลวในการอัปโหลดเซิร์ฟเวอร์รูปภาพ',
    10024: 'บุคลากรปัจจุบันของดิวิชั่นไม่สามารถลบออกได้!',
    10025: 'มีองค์กรอยู่ในปัจจุบัน และไม่สามารถลบออกได้!',
    10026: 'มี บริษัท ย่อยอยู่ในองค์กรปัจจุบัน และไม่สามารถลบได้!',
    10027: 'มีหน่วยย่อยอยู่ในปัจจุบัน และไม่สามารถลบได้!',
    10028: 'มีหมายเลขโทรศัพท์อยู่แล้ว',
    10029: 'มีหมายเลขประจำตัวอยู่แล้ว',
    10030: 'มีกล่องจดหมายอยู่แล้ว',
    10031: 'ตำแหน่ง ที่เลือกอยู่ในระดับล่าง และไม่สามารถลบได้!',
    10032: 'รหัสผ่านในการล็อกอินหมดอายุแล้วโปรดตั้งค่ารหัสผ่านใหม่อีกครั้งใน "จดหมายไมโครซิส" หรือคลิก ที่ "ลืมรหัสผ่าน"',
    10033: 'รหัสผ่านสำหรับล็อกอินหมดอายุ % 1 วันโปรดแก้ไขรหัสผ่านในเวลา ที่เหมาะสม',
    10034: 'เข้าสู่ระบบครั้งแรกโปรดแก้ไขรหัสผ่านก่อน',
    10035: 'โปรแกรม ที่เลือกจะถูกอ้างอิง และไม่สามารถลบได้!',
    10036: 'ตัวละคร ที่เลือกมีการอ้างอิง และไม่สามารถลบได้!',
    10037: 'ผู้มีชีวิตอยู่ในปัจจุบัน, ไม่สามารถลบออกได้!',
    10038: 'มีตำแหน่งเชื่อมโยงอยู่แล้ว',
    10039: 'ป้อนข้อผิดพลาด % 1 รายการจะถูกล็อค!',
    10040: 'รหัสผ่านมีอย่างน้อย 8 บิตตัวเลขตัวเลขตัวอักษรพิเศษ'
  }
}
